/**
 * Returns an array of page numbers
 * for a given number of items and number
 * of items shown per page
 *
 * @param numOfItems Total number of items
 * @param itemsPerPage Items per page
 * @param maxNumberOfPages  Defaults to 25 max pages
 */
export const makeTotalPagesArray = (
  numOfItems: number,
  itemsPerPage: number,
  maxNumberOfPages: number = 25
) => {
  if (itemsPerPage === 0) {
    return [];
  }
  const totalPages = Math.ceil(numOfItems / itemsPerPage);
  const arr = [];
  let i = 0;
  while (i < totalPages && i < maxNumberOfPages) {
    arr.push(i++);
  }

  return arr;
};
